import { render, staticRenderFns } from "./RouteToInteractions.vue?vue&type=template&id=401f2fd7&"
import script from "./RouteToInteractions.vue?vue&type=script&lang=js&"
export * from "./RouteToInteractions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports